import React, { Component } from 'react';
import AlertErrorOutline from 'material-ui/svg-icons/alert/error-outline';
import Dialog from 'material-ui/Dialog';
import './InstallWebGL.css';

export default class InstallWebGL extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen() {
    console.log('clicked');
    this.setState({
      open: true
    });
  }

  handleClose() {
    this.setState({
      open: false
    })
  }

  render () {

    return (
      <div className="install-webgl-container">
        <div className="install-webgl">
          <AlertErrorOutline style={{
              color: 'white',
              verticalAlign: 'middle',
              marginRight: '5px'
            }} /> Please enable WebGL for the full map. &nbsp;
            <span className="learn-more"
              onClick={this.handleOpen}>
              Learn more
            </span>
        </div>
        <Dialog
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleClose}
          contentClassName="install-webgl-dialog"
          autoScrollBodyContent={true}
        >
          This map works better with <a href="https://get.webgl.org/" target="_blank">WebGL</a> enabled. WebGL is a cross-platform web standard for 3D graphics. When enabled, you can view the full route map with mile markers, hydration stops, medical stations, and more.
          <br /><br />
          To enable WebGL, try updating your browser or following the <a href="http://superuser.com/questions/836832/how-can-i-enable-webgl-in-my-browser" target="_blank">instructions here</a>. As a temporary solution, you can also try using Safari.
        </Dialog>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/fallback/InstallWebGL.jsx